export const DEFAULT_TRIAL_DAYS = 14;
